<template>
  <div class="interview-edit-form">

    <v-card-title style="text-align: center; display: block; font-size: 18px; padding-bottom: 0;">
      Редактирование интервью
    </v-card-title>

    <v-card-text class="container-interview">
      <div class="container-user-interview">
        <div class="h-v-center">
          <div class="container-img">
            <div
              v-if="hasAvatar(editableItem)"
              class="custom-bg-img"
              :style="avatarStyle(editableItem.interviewee.avatar)"
            />
            <img v-else src="@/assets/img/no-foto.png" />
          </div>
        </div>

        <div class="right-block-interview">
          <h4>{{ editableItemUserName }}</h4>
          <p>Кандидат</p>
        </div>
      </div>

      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-container>
          <v-row>

            <v-col cols="12" class="container-field-interview">
              <label class="field-label">Название</label>
              <v-text-field
                v-model="editableItem.title"
                :rules="textRules"
                dense
                required
              />
            </v-col>

            <v-col cols="12" class="container-field-interview">
              <label class="field-label">Дата</label>
              <v-text-field
                v-model="editableItem.dateTime"
                type="datetime-local"
                :rules="textRules"
                dense
                required
              />
            </v-col>

            <v-col cols="12" class="custom-selected1 container-field-interview">
              <label class="field-label mb-0">Участники</label>
              <multiselect 
                class="custom-ul"
                v-model="participants" 
                placeholder="Введите для поиска" 
                label="title" 
                track-by="id"
                :multiple="true"
                :options="options" 
                :option-height="90" 
                :custom-label="customLabel" 
                :close-on-select="false"
                :show-labels="false"
              >
                <span slot="noResult">Нет результатов</span>
                <template slot="singleLabel" slot-scope="props">
                  <span style="display:none">{{props.option.id}}</span>
                  <img class="option__image select-img" :src="props.option.img">
                  <span class="option__desc">
                    <span class="option__title">{{ props.option.title }}</span>
                  </span>
                </template>
                <template slot="option" style="display:flex" slot-scope="props">
                  
                  <div class="option__desc">
                    <span style="display:none">{{props.option.id}}</span>
                    <img v-if="props.option.img != 'noFoto'" class="option__image select-img" style="margin-right: 10px; border-radius: 30px" :src="props.option.img">
                    <img v-else class="option__image select-img" style="margin-right: 10px; border-radius: 30px" src="@/assets/img/no-foto.png" alt="" />
                    <span class="option__title">{{ props.option.title }}</span>
                  </div>
                </template>
              </multiselect>
            </v-col>

            <v-col cols="12" class="custom-selected1 container-field-interview ">
                <label class="field-label mb-0">Тип интервью</label>
                <multiselect
                  class="custom-ul"
                  v-model="typeInterview"
                  placeholder="Выберите тип интервью"
                  label="title"
                  track-by="title"
                  :options="optionsTypeInterview"
                  :custom-label="customLabelInterview"
                  :option-height="10" 
                  :searchable="false"
                  :allow-empty="false"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  @input="typeError = false"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <div style="display:flex; align-items: center;">
                      <span class="option__desc">
                        <span class="option__title">{{ props.option.name }}</span>
                      </span>
                    </div>
                  </template>

                  <template slot="option" slot-scope="props">
                    <div style="display:flex; align-items: center;">
                      <div class="option__desc">
                        <span class="option__title"
                              style="font-size: 14px; font-family: 'Montserrat', sans-serif;">
                          {{ props.option.name }}
                        </span>
                      </div>
                    </div>
                  </template>
                </multiselect>
                <div v-if="typeError" class="v-messages__message v-messages error--text mt-1">
                  Обязательно
                </div>
            </v-col>

            <v-col cols="12" class="text-center">
              <v-btn
                v-if="!btnLoader" 
                type="submit"
                class="btnSave primary-btn"
                @click.prevent="updateEditedEntity"
              >
                Сохранить
              </v-btn>
              <v-btn 
                v-else 
                type="submit" 
                class="btnSave primary-btn"
              >
                <v-progress-circular indeterminate></v-progress-circular>
              </v-btn>
            </v-col>

          </v-row>
        </v-container>
      </v-form>
    </v-card-text>

  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import GlobalRequest from "@/plugins/globalRequest";

export default {
  name: "InterviewEditForm",

  components: {
    Multiselect
  },

  props: {
    data: {
      type: Object,
      required: true
    },

    options: {
        type: Array,
        default: () => []
    },
  },

  data() {
    return {
      valid: false,

      editableItem: {},

      participants: [],

      files: {},
      sliderValue: 0.1,

      noPhoto: require("@/assets/img/no-foto.png"),

      textRules: [
        function (v) {
          return !!v || "Поле обязательно для заполнения";
        }
      ],

      btnLoader: false,

      typeInterview: null,
      typeError: false,
      optionsTypeInterview: []
    };
  },

  computed: {
    editableItemUserName() {
      if (
        !this.editableItem ||
        !this.editableItem.interviewee
      ) {
        return "";
      }

      const lastName = this.editableItem.interviewee.lastName || "";
      const name = this.editableItem.interviewee.name || "";

      return `${lastName} ${name}`.trim();
    }
  },

  mounted() {
    this.editableItem = JSON.parse(JSON.stringify(this.data));

    // если участники уже есть
    if (this.editableItem.participants) {
      let usersPart = [];
      for (const user of this.editableItem.participants) {
        usersPart.push({
          id: user.id,
          title: `${user.name} ${user.lastName || ""}`,
          img: user.avatar || "noFoto"
        });
      }

      this.participants = usersPart;
    }

    // Получить список типов интервью
    this.getData();

    // Выбранный тип интервью
    if (this.editableItem.type) {
      this.typeInterview = this.editableItem.type;
    }
  },

  methods: {
    async getData() {
      const resTypes = await GlobalRequest.request(`/interviews/types`, "GET");
      if(resTypes) {
        this.optionsTypeInterview = resTypes || [];
      }
    },

    async updateEditedEntity() {
      var valid = this.$refs.form.validate();

      if (!this.typeInterview) {
        this.typeError = true;
      } else {
        this.typeError = false;
      }

      if (!valid || !this.typeInterview) return;

      this.btnLoader = true;

      const body = {
        title: this.editableItem.title,
        dateTime: this.editableItem.dateTime,
        interviewee: this.editableItem.interviewee.id,
        participants: this.participants.map(p => p.id),
        owner: this.editableItem.owner.id,
        type: this.typeInterview.title || ""
      };

      const res = await GlobalRequest.request("/interviews/update/" + this.editableItem.id, "PUT", body);

      this.$emit("saveEditedInterview", res);
    },

    customLabel ({ title }) {
      return `${title}`
    },

    hasAvatar(obj) {
      return obj && obj.interviewee && obj.interviewee.avatar;
    },

    avatarStyle(path) {
      return {
        backgroundImage: 'url("' + path + '")',
        width: "100%",
        height: "100%"
      };
    },

    customLabelInterview(item) {
      if (!item) return "";
      return item.title || "";
    },
  }
};
</script>

<style scoped>
.field-label {
  display: block;
  margin-bottom: 4px;
  font-size: 13px;
  color: rgba(0, 0, 0, .6);
}

.option {
  display: flex;
  align-items: center;
}

.option__image {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 10px;
  object-fit: cover;
}

.option__title {
  font-size: 14px;
}

.btnSave {
  min-width: 140px;
}
.container-user-interview {
  padding: 20px 0 14px;
}
.container-user-interview h4 {
  padding: 0;
  margin: 0;
  font-weight: 500;
  color: #000;
  font-size: 18px;
}
.container-user-interview p {
  padding: 0;
  margin: 0;
  font-size: 16px;
  text-align: left;
}
.container-user-interview .h-v-center {
  display: flex !important;
}
.right-block-interview {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
}
.container-interview {
    padding: 0 24px 20px;
}
.container-field-interview {
  padding: 0 0 20px;
}
</style>
